import baseReducer from "../../billecta/reducer";
import constants from "./constants";

export default (state, action) => {
  const { type, payload } = action;

  let newState = baseReducer(state, action, constants);

  switch (type) {
    case constants.DESTROY_FORM: {
      return { ...newState, forms: {} };
    }

    case constants.SET_SEARCH_RESULT: {
      return { ...newState, searchResult: payload.result };
    }

    case constants.SET_CUSTOM_SEARCH_RESULT: {
      return { ...newState, [payload.name]: payload.result };
    }

    default:
      return newState;
  }
};
